export function exportCSV(headers, rows, filename) {
  const BOM = '﻿';
  const sanitize = v => { const s = String(v ?? ''); return /^[=+\-@\t\r]/.test(s) ? "'" + s : s; };
  const escape = v => `"${sanitize(v).replace(/"/g, '""')}"`;
  const csv = BOM + [headers, ...rows].map(row => row.map(escape).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export function escapeHtml(s) {
  return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// 検査番号（serial）はinspection_serial_countersにより企業ごとの連番で採番されるため、
// 異なる企業・異なるアプリ（姉妹アプリfood-label-assist）の検査と番号が重複しうる。
// support@ok-retail.com（PM/FLA共通の問い合わせ窓口）に検査番号だけを伝えられても
// どちらのアプリの検査か分からなくなるため、画面表示・PDF・CSV等で検査番号を示す際は
// 必ずこの関数を通し、アプリコード（PM-）を前置する。
// fallbackは検査番号がまだ付いていない場合の表示。既定は空文字（バッジ等、番号が無いなら
// 何も出さない箇所向け）。PDFやCSVのように「欄が空なだけ」と「番号が付いていない」を
// 区別したい箇所では '未保存' のような文言を明示的に渡す（food-label-assistと同じ方式）
export function formatSerial(serial, fallback = '') {
  return serial != null ? `PM-${serial}` : fallback;
}

// iOS端末（iPhone/iPad、iPadOS13+のMacIntel偽装込み）かどうかの判定。
// navigator.shareのアクティベーション制約回避（usePendingPdfShare参照）等、
// App.js/AdminPanel.js/SuperAdminPanel.jsで全く同じ判定式が個別に書かれていたため共通化
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// User-Agentから簡易な端末種類を判定（PC/iPhoneでの画像圧縮差など、環境依存の判定結果を後から調査するため）
export function getDeviceType(ua) {
  const s = ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const isTouchMac = typeof navigator !== 'undefined' && /Macintosh/i.test(s) && navigator.maxTouchPoints > 1;
  if (/iPad/i.test(s) || isTouchMac) return 'iPad';
  if (/iPhone|iPod/i.test(s)) return 'iPhone';
  if (/Android/i.test(s)) return /Mobile/i.test(s) ? 'Android' : 'Android(タブレット)';
  if (/Macintosh/i.test(s)) return 'PC(Mac)';
  if (/Windows/i.test(s)) return 'PC(Windows)';
  if (/Linux/i.test(s)) return 'PC(Linux)';
  return '不明';
}

// User-Agentから簡易なブラウザ種類を判定する。iOSのChrome/Firefox/EdgeはSafari同様
// WebKitベースだがUA内に固有トークン（CriOS/FxiOS/EdgiOS等）を含むため、それらを
// 先に判定してからSafari判定にフォールバックする（順序が重要）。
export function getBrowserType(ua) {
  const s = ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  if (/EdgiOS|EdgA|Edg\//i.test(s)) return 'Edge';
  if (/OPiOS|OPR\//i.test(s)) return 'Opera';
  if (/FxiOS|Firefox/i.test(s)) return 'Firefox';
  if (/SamsungBrowser/i.test(s)) return 'Samsung Internet';
  if (/CriOS|Chrome/i.test(s)) return 'Chrome';
  if (/Safari/i.test(s)) return 'Safari';
  return '不明';
}
